export default __webpack_public_path__ + "static/media/aquis.9fb4c0cc.png";